import { AfterViewInit, ChangeDetectorRef, Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { CategoryItemComponent } from '../../shared/category-item/category-item.component';
import { Router } from '@angular/router';
import { SearchBarComponent } from '../../shared/search-bar/search-bar.component';
import { SortByComponent } from '../../shared/sort-by/sort-by.component';
import { AuthService } from '../../services/auth/auth.service';
import { Category } from '../../models/category';
import { PagingComponent } from "../../shared/paging/paging.component";
import { Project } from '../../models/project';
import { cloneDeep } from 'lodash';
import { SortByEnum } from '../../enums/sortEnum.enum';
import { FiltersModalComponent } from '../../shared/filters-modal/filters-modal.component';
import { SearchByComponent, SearchOption } from '../../shared/search-by/search-by.component';
import { RouteEnum } from '../../enums/routes.enum';
import { IFilter } from '../../models/filter';
import { MaterialModule } from '../../material/material.module';
import { PermissionsEnum } from '../../enums/permissions.enum';
import { TabCategoryEnum } from '../../enums/tabCategory.enum';
import { PagingQueryOptions } from '../../models/pagingQueryOptions ';
import { RoleEnum } from '../../enums/role.enum';
import { isNullOrUndefined } from '@pineapplelab/util';
import { CategoryService } from '../../services/category/category.service';
import { SharedModule } from '../../shared/shared.module';
import { ProjectService } from '../../services/project/project.service';
import { AssignedCategoryService } from '../../services/assigned-category/assigned-category.service';
@Component({
	selector: 'app-category-list',
	standalone: true,
	templateUrl: './category-list.component.html',
	styleUrl: './category-list.component.scss',
	imports: [
		SharedModule,
		CategoryItemComponent,
		SearchBarComponent,
		SortByComponent,
		FiltersModalComponent,
		SearchByComponent,
		MaterialModule,
	]
})
export class CategoryListComponent implements AfterViewInit {

	projectId = this.authService.projectId;
	allCategories: Category[] = [];
	showSpinner = true;
	data: Category[] = [];
	pagingData: Category[] | undefined;
	searchTerm: string = '';
	searchBy: string = 'name_lowercase';
	sortingValue: SortByEnum = SortByEnum.RECENTLY_CREATED;
	searchOptions: SearchOption[] = [
		{ value: 'name_lowercase', label: 'general.name' },
		{ value: 'id', label: 'general.id' },
	];
	assignedCategories: Category[] = [];
	originalAssignedCategories: Category[] = [];
	selectedTabCategory: TabCategoryEnum = TabCategoryEnum.MY_CATEGORIES;
	TabCategoryEnum = TabCategoryEnum;
	filtersByUserId: IFilter[] = [
		{ property: 'created_by', value: this.authService.auth.user.id, isArray: false },
	];
	@ViewChild(PagingComponent) pagingComponent: PagingComponent;
	@ViewChildren(CategoryItemComponent) categoryItemsComponent: QueryList<CategoryItemComponent>;
	PermissionsEnum = PermissionsEnum;
	authUser = this.authService.auth?.user;
	Roles = RoleEnum;
	showAssignedSpinner: boolean = false;
	hasAssignedData: boolean = false;
	currentPage: number = 1;

	queryOptions: PagingQueryOptions = {
		path: `${Project.PATH}/${this.authService.projectId}/${Category.PATH}`,
		pageSize: 8,
		filters: [],
		orderBy: 'created_at',
		orderDirection: 'desc',
	}

	constructor(
		private router: Router,
		private authService: AuthService,
		private cdr: ChangeDetectorRef,
		private categoryService: CategoryService,
		private projectService: ProjectService,
		private assignedCategoryService: AssignedCategoryService
	) { }

	getFilters(role: RoleEnum): IFilter[] {
		if (isNullOrUndefined(role)) {
			return [];
		}

		if (role === RoleEnum.ADMIN) {
			return [{ property: 'created_by_admin', value: true, isArray: false }];
		}

		return [{ property: 'created_by', value: this.authService.auth?.user?.id, isArray: false }];
	}

	ngAfterViewInit(): void {
		this.collapseAllItems();
	}

	redirectToCreateCategory(): void {
		this.router.navigateByUrl(`/${RouteEnum.CATEGORY_CREATION}`);
	}

	async ngOnInit() {
		const state = this.router.getCurrentNavigation()?.extras.state;
		if(state?.['fromCreation']){
			this.selectedTabCategory = TabCategoryEnum.MY_CATEGORIES;
		}
		if(this.authUser?.role === this.Roles.CONTENT_CREATOR && this.assignedCategories.length > 0 && !state?.['fromCreation'] ){
			this.selectedTabCategory = TabCategoryEnum.ASSIGNED_CATEGORIES;
		}

		this.queryOptions.filters = [
			...this.getFilters(this.authService.auth?.user?.role),
			{ property: 'is_hidden', value: false, isArray: false },
		];
		this.showAssignedSpinner = true;
		this.originalAssignedCategories = await this.getAssignedCategories();		
		this.assignedCategories = this.originalAssignedCategories;
		this.hasAssignedData = !!this.assignedCategories?.length;
		this.showAssignedSpinner = false;
	}

	getPagingData(data: any) {
		this.data = data?.map((category: any) => new Category(category))
		if (!this.pagingData) {
			this.pagingData = cloneDeep(this.data);
		}
		this.showSpinner = false;
		this.collapseAllItems();
	}

	async handleDataChange(ev: boolean): Promise<void> {
		this.showSpinner = true;
		await this.pagingComponent.loadPage(this.currentPage);
		this.showSpinner = false;
	}

	handleEventChange(ev: boolean): void {
		if(ev){
			this.selectedTabCategory = TabCategoryEnum.MY_CATEGORIES;
		}
	}

	onTabChange(ev: any): void {
		this.selectedTabCategory = ev.index;
	}


	async handleFilteredItems(searchString: string): Promise<void> {
		this.updateQueryOptions({ searchText: searchString });
		this.updateOrderByBasedOnSearchBy(this.searchBy);
		this.updateOrderByBasedOnSearch()
		this.cdr.detectChanges();
	}

	handleSortOptionSelected(option: SortByEnum): void {
		this.sortingValue = option;
		this.updateOrderByBasedOnSort(option);
	}

	handleSearchBySelected(ev: string): void {
		this.searchBy = ev;
		this.updateOrderByBasedOnSearchBy(ev);
	}

	collapseAllItems() {
		this.categoryItemsComponent.forEach((item) => item.collapse());
		this.cdr.detectChanges();
	}

	private updateOrderByBasedOnSearch(): void {
		if (this.queryOptions.searchText.length) {
			this.sortingValue = SortByEnum.ALPHABETICAL;
			this.updateOrderByBasedOnSearchBy(this.searchBy);
		}
	}

	private updateOrderByBasedOnSort(option: SortByEnum): void {
		switch (option) {
			case SortByEnum.RECENTLY_CREATED:
				this.updateQueryOptions({ orderBy: 'created_at', orderDirection: 'desc', refreshPage: true });
				break;
			case SortByEnum.ALPHABETICAL:
				this.updateQueryOptions({ orderBy: 'name_lowercase', orderDirection: 'asc', refreshPage: true });
				break;
			default:
				break;
		}
	}

	private updateQueryOptions(newOptions: Partial<typeof this.queryOptions>): void {
		this.queryOptions = {
			...this.queryOptions,
			...newOptions
		};
	}

	private updateOrderByBasedOnSearchBy(searchBy: string): void {
		this.searchBy = searchBy;
		this.updateQueryOptions({ orderBy: searchBy, refreshPage: false });
	}

	private async getAssignedCategories(){
		return this.assignedCategoryService.getCategoriesAssigned(this.authService.projectId, this.authService.auth?.user?.id);
	}

	search(term: string): void {
		if (this.searchBy === 'id') {
			this.assignedCategories = this.originalAssignedCategories?.filter(category => category?.id?.toLowerCase().includes(term.toLowerCase()));
		} else {
			this.assignedCategories = this.originalAssignedCategories?.filter(category => category?.name?.toLowerCase().includes(term.toLowerCase()));

		}
	}
	clear(){
		this.searchTerm = '';
		this.assignedCategories = this.originalAssignedCategories
	}

	hasPermission(permission: PermissionsEnum): boolean {
		return this.projectService.hasPermissions(permission);
	}

}
